const CHUNK_RELOAD_STORAGE_KEY = 'simpli5-chunk-reload-count'
const MAX_CHUNK_RELOADS = 2

export function isChunkLoadError(error) {
  if (!error) return false
  if (error.name === 'ChunkLoadError') return true

  const message = String(error.message || '')
  return (
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  )
}

function getChunkReloadCount() {
  try {
    return Number(sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) || 0)
  } catch {
    return MAX_CHUNK_RELOADS
  }
}

export function canOfferChunkReload() {
  return getChunkReloadCount() < MAX_CHUNK_RELOADS
}

export function reloadForChunkError() {
  if (!canOfferChunkReload()) return

  try {
    sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(getChunkReloadCount() + 1))
  } catch {
    return
  }

  window.location.reload()
}
